<template>
  <div v-if="currentRoles.name === '人员管理'" class="page-index user-member">
    <div class="toolbar-box">
      <el-button v-if="currentRoles.roles['人员管理-新增']" class="btn-left" size="mini" @click="openModel">添加用户</el-button>
      <div style="flex:1"></div>
      <el-select class="search-input" v-model="status" @change="seach">
        <el-option label="使用中" value="0"></el-option>
        <el-option label="已禁用" value="1"></el-option>
      </el-select>
      <el-input  class="search-input" size="mini" v-model="query" @keyup.enter.native="seach" placeholder="请输入用户名或者账号" />
    </div>
    <el-table
        ref="userTable"
        :data="userList"
        stripe
        size="mini"
        empty-text="暂无数据"
        row-class-name="table-row-cursor"
        header-row-class-name="header-row"
        :height="tableHeight"
        :maxHeight="tableHeight"
        style="width: 100%;">
      <el-table-column
          header-align="center"
          align="center"
          type="index"
          :index="indexMethod"
          width="50"
          label="#">
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          width="100"
          prop="name"
          label="用户名称">
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          width="100"
          prop="loginCode"
          label="账号">
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          prop="companyName"
          label="管理公司">
        <template slot-scope="scope">
          <div v-if="scope.row.companyList && scope.row.companyList.length > 0">
            <div v-for="item in scope.row.companyList" :key="item.id">{{item.name}}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          prop="createTime"
          label="加入时间">
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          prop="status"
          label="状态">
        <template slot-scope="scope">
          <div>{{scope.row.status == 1 ? '已停用' : '使用中'}}</div>
        </template>
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          width="240"
          label="操作">
        <template slot-scope="scope">
          <div v-if="currentRoles.roles['人员管理-禁用']" style="display:inline-block;margin-right:10px;">
            <el-tooltip content="禁用" placement="top">
              <el-button v-if="scope.row.status === 0" size="mini" @click.stop="handleSwitch(scope.row)">
                <i class="icon el-icon-disable"></i>
              </el-button>
            </el-tooltip>
            <el-tooltip v-if="scope.row.status === 1" content="启用" placement="top">
              <el-button size="mini" @click.stop="handleSwitch(scope.row)">
                <i class="icon el-icon-enable"></i>
              </el-button>
            </el-tooltip>
          </div>
          <el-tooltip v-if="currentRoles.roles['人员管理-密码重置']" content="初始化密码" placement="top">
            <el-button size="mini" @click.stop="handleInitPwd(scope.row)">
              <i class="icon el-icon-pwd-reset"></i>
            </el-button>
          </el-tooltip>
          <el-tooltip v-if="currentRoles.roles['人员管理-编辑']" content="编辑" placement="top">
            <el-button size="mini" @click.stop="openModel2(scope.row)">
              <i class="icon el-icon-edit"></i>
            </el-button>
          </el-tooltip>
          <el-tooltip v-if="currentRoles.roles['人员管理-删除']" content="删除" placement="top">
            <el-button size="mini" @click.stop="handleDelete(scope.row)">
              <i class="icon el-icon-delete"></i>
            </el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
        :current-page.sync="pageIndex"
        @current-change="pageChange"
        layout="->, total, prev, pager, next"
        :page-size="pageSize"
        :total="total"
        class="pagination">
    </el-pagination>

    <el-dialog
        title="添加用户"
        :visible.sync="dialogVisible"
        width="550px"
        :before-close="handleClose">
      <el-form ref="addUser" :rules="rules" :model="form" label-width="180px">
        <el-form-item label="用户名称" prop="name">
          <el-input placeholder="请输入用户名称" v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="账号" prop="loginCode">
          <el-input placeholder="请输入账号" v-model="form.loginCode"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input placeholder="请输入密码" v-model="form.password" show-password></el-input>
        </el-form-item>
        <el-form-item label="公司" prop="companyIds">
          <el-select
            class="search-user"
            v-model="form.companyIds"
            multiple
            collapse-tags
            filterable
            remote
            :remote-method="_getCompanyList"
            placeholder="请选择公司"
          >
            <el-option v-for="item in companyList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="角色" prop="roleId">
          <el-select v-model="form.roleId"  placeholder="请选择角色">
            <el-option v-for="item in roleList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <el-form v-if="userInfo.organizationId === 1" ref="organization" :rules="rules2" :model="form" label-width="180px">
        <el-form-item label="组织" prop="organizationId">
          <el-select v-model="form.organizationId" placeholder="请选择组织">
            <el-option v-for="item in tree2List" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addUser">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
        title="修改用户"
        :visible.sync="dialogVisible2"
        width="550px"
        :before-close="handleClose">
      <el-form ref="editUser" :rules="rules" :model="form" label-width="180px">
        <el-form-item label="用户名称" prop="name">
          <el-input placeholder="请输入用户名称" v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="选择公司" prop="companyIds">
          <el-select
            class="search-user"
            v-model="form.companyIds"
            filterable
            multiple
            collapse-tags
            remote
            :remote-method="_getCompanyList"
            placeholder="请选择公司"
          >
            <el-option v-for="item in companyList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="角色" prop="roleId">
          <el-select v-model="form.roleId"  placeholder="请选择角色">
            <el-option v-for="item in roleList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <el-form v-if="userInfo.organizationId === 1" ref="organization" :rules="rules2" :model="form" label-width="180px">
        <el-form-item label="选择组织" prop="organizationId">
          <el-select v-model="form.organizationId" placeholder="请选择组织">
            <el-option v-for="item in tree2List" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible2 = false">取 消</el-button>
        <el-button type="primary" @click="editUser">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
  import { tableMixin } from '../../mixins/table'
  import { mapGetters } from 'vuex'
  import { formatDate } from '../../utils/common'
  import { apiGetList, apiDelete, apiEdit, apiSwitch, apiChangePwd } from '../../api/user'
  import { apiList, apiTree } from '../../api/organization'
  import { apiRoleList } from '../../api/role'

  export default {
    mixins: [tableMixin],
    name: 'userInfo',
    data() {
      return {
        dialogVisible: false,
        dialogVisible2: false,
        userList: [],
        companyList: [],
        tree2List: [],
        pageIndex: 1,
        total: 0,
        id: '',
        query: '',
        status: '0',
        roleList: [],
        companyId: '',
        form: {
          name: '',
          loginCode: '',
          password: '',
          organizationId: '',
          roleId: '',
          companyIds: []
        },
        rules: {
          name: [
            { required: true, message: '请输入用户名称', trigger: 'blur' },
            { max: 50, message: '长度在 50 个字符以内', trigger: 'blur' }
          ],
          loginCode: [
            { required: true, message: '请输入账号', trigger: 'blur' },
            { min: 6, max: 20, message: '长度在 6 到 20 个字符', trigger: 'blur' }
          ],
          password: [
            { required: true, message: '请输入密码', trigger: 'blur' },
            { min: 6, max: 20, message: '长度在 6 到 20 个字符', trigger: 'blur' }
          ],
          companyIds: [
            { required: true, message: '请选择公司', trigger: 'change' }
          ],
          roleId: [
            { required: true, message: '请选择角色', trigger: 'change' }
          ]
        },
        rules2: {
          organizationId: [
            { required: true, message: '请选择组织', trigger: 'change' }
          ]
        }
      }
    },
    computed: {
      ...mapGetters([
        'userInfo',
        'roles',
        'currentRoles'
      ])
    },
    created() {
      // this._getList()
      // this._getCompanyList()
      // this._getTree()
    },
    activated() {
      this._getList()
      this._getCompanyList()
      this._getTree()
      this._getRole()
    },
    methods: {
      indexMethod(index) {
        return (this.pageIndex - 1) * 20 + index + 1
      },
      // 打开model
      openModel() {
        this.dialogVisible = true
        this.form = {
          name: '',
          loginCode: '',
          password: '',
          organizationId: '',
          roleId: '',
          companyIds: []
        }
        if (this.$refs['addUser']) {
          this.$refs['addUser'].resetFields()
        }
        if (this.$refs['organization']) {
          this.$refs['organization'].resetFields()
        }
      },
      openModel2(row) {
        this.dialogVisible2 = true
        this.form = {
          name: row.name,
          roleId: '',
          organizationId: row.organizationId,
          companyIds: ''
        }
        let arr = []
        row.companyIds.split(',').forEach(item => {
          arr.push(parseInt(item))
        })
        this.form.companyIds = arr
        this.id = row.id
        if (this.$refs['editUser']) {
          this.$refs['editUser'].resetFields()
        }
      },
      // 翻页
      pageChange(pageIndex) {
        this.pageIndex = pageIndex
        this._getList(pageIndex)
      },
      // 关闭对话框
      handleClose() {
        this.$confirm('确认关闭？').then(_ => {
          this.dialogVisible = false
          this.dialogVisible2 = false
        }).catch(_ => {})
      },
      // 搜索
      seach() {
        this.pageIndex = 1
        this._getList()
      },
      // 获取角色
      _getRole() {
        apiRoleList(1, 999).then(data => {
          this.roleList = data.data.data
        })
      },
      // 获取公司列表
      _getCompanyList(value = '') {
        apiList(value, 0, 1, 999).then(data => {
          this.companyList = data.data.data
        })
      },
      // 获取组织树
      _getTree() {
        this.tree2List = []
        apiTree().then(data => {
          this.tree4mate(data.data)
        })
      },
      // 格式化组织树
      tree4mate(data) {
        if (data.isCompany === 0 && data.parentId !== null) {
          this.tree2List.push({
            name: data.name,
            id: data.id
          })
        }
        if (data.childrenList !== undefined & data.childrenList !== null) {
          data.childrenList.forEach(item => {
            this.tree4mate(item)
          })
        }
      },
      // 获取列表
      _getList(pageIndex = 1) {
        apiGetList(this.query, this.status, pageIndex).then(data => {
          this.userList = data.data.data
          this.total = data.data.total
        })
      },
      // 新增
      addUser() {
        let user = this.form
        this.$refs['addUser'].validate((valid) => {
          if (this.userInfo.organizationId === 1) {
            this.$refs['organization'].validate((valid2) => {
              if (valid && valid2) {
                user.companyIds = user.companyIds.join(',') || ''
                apiEdit(user).then(() => {
                  this.$message({
                    type: 'success',
                    message: '新增成功'
                  })
                  this.dialogVisible = false
                  this._getList()
                })
              }
            })
          } else {
            if (valid) {
              user.organizationId = this.userInfo.organizationId
              user.companyIds = user.companyIds.join(',') || ''
              apiEdit(user).then(() => {
                this.$message({
                  type: 'success',
                  message: '新增成功'
                })
                this.dialogVisible = false
                this._getList()
              })
            }
          }
        })
      },
      // 编辑
      editUser() {
        let user = {
          id: this.id,
          name: this.form.name,
          roleId: this.form.roleId,
          organizationId: this.form.organizationId,
          companyIds: this.form.companyIds.join(',') || ''
        }
        apiEdit(user).then(() => {
          this.$message({
            type: 'success',
            message: '编辑成功'
          })
          this.dialogVisible2 = false
          this._getList()
        })
      },
      // 初始化密码
      handleInitPwd(row) {
        this.$confirm(`是否将用户：${row.name}密码初始化`, '提示', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          apiChangePwd(row.id, '', '', 1).then(() => {
            this.$message({
              type: 'success',
              message: '密码初始化成功'
            })
          })
        })
      },
      // 删除
      handleDelete(row) {
        this.$confirm(`是否删除用户：${row.name}`, '提示', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          apiDelete(row.id).then(() => {
            this.$message({
              type: 'success',
              message: '删除成功'
            })
            this._getList()
          })
        })
      },
      handleSwitch(row) {
        this.$confirm(`是否${row.status === 0 ? '停用' : '启用'}用户：${row.name}`, '提示', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          apiSwitch(row.id).then(() => {
            this.$message({
              type: 'success',
              message: `${row.status === 0 ? '停用' : '启用'}成功`
            })
            this._getList()
          })
        })
      }
    }
  }
</script>

<style lang="stylus">
  .page-index.user-member
    .el-form-item__content
      width 200px
    .btn-left
      background #A5CE1C
      color #fff
    .el-table
      .has-gutter
        th
          background #F5F7FA
          border-right 1px solid #EBEEF5
          border-top 1px solid #ebeef5
    .toolbar-box
      display flex
      margin 10px 0
      .search-input
        width 150px
        margin-right 10px
        .el-input__inner
          height 36px
          line-height 36px
      .select-box
        width 120px
        margin-right 10px
    .upload
      .el-upload
        width 100%
        .el-upload-dragger
          width 100%
    .search-user.el-select
      width 200px
      .el-select__tags
        width 200px !important
        max-width 200px !important
        & > span
          display flex
        .el-tag__close.el-icon-close
          top -7px
        .el-select__tags-text
          display inline-block
          max-width 110px
          overflow hidden
          text-overflow ellipsis
          white-space nowrap
    .el-select-dropdown__item.selected
      span
        display inline-block
        max-width 110px
        overflow hidden
        text-overflow ellipsis
        white-space nowrap
</style>
